import dev from './dev.config.json'
import prod from './prod.config.json'

let config: any = {}
switch (window.location.hostname) {
  case 'planner.preplaced.in':
    config = { ...prod }
    break
  default:
    config = { ...dev }
}

export default config
